import { Components } from "@/app/(components)/_components/Components";
import { ModalType } from "@/app/(components)/generics/Modal/Modal";
import { ModalStore } from "@/app/stores/ModalStore";
import { TFn } from "@/app/translations/TFn";
import { TKey } from "@/app/translations/TKey";
import { AvatarField, UserClientAvatar } from "@/app/types/client-avatar/UserClientAvatar";

const MOCK_AVATAR_DEFAULTS: Omit<
  UserClientAvatar,
  "id" | "uuid" | "type" | "name" | "role" | "gender" | "ageRange" | "snapshotSummary" | "avatarUrl"
> = {
  offerId: 0,
  locationRange: [],
  educationLevel: null,
  incomeRange: null,
  companyType: null,
  companySize: null,
  market: null,
  priority: null,
  dataSources: [],
  scoreFit: null,
  scoreConfidence: null,
  scorePain: null,
  desires: [],
  frustrations: [],
  dreams: [],
  fears: [],
  costTime: null,
  costEnergy: null,
  costOpportunity: null,
  currentSituation: [],
  desiredSituation: [],
  dailyRoutine: null,
  mindset: null,
  blockers: [],
  falseBelief: [],
  purchaseObjections: [],
  objectionHandler: [],
  privateQuotes: [],
  publicQuotes: [],
  dominantKeywords: [],
  emotionalLanguage: [],
  copyAdvice: null,
  fitSummary: null,
  urgencyLevel: null,
  urgencyDescription: null,
  purchasePotential: null,
  purchasePotentialDescription: null,
  idealClientCriteria: [],
  nonIdealClientCriteria: [],
  purchaseTriggers: [],
  whereToFind: [],
  voiceOfTrust: null,
  approachAngle: null,
};

export function openAvatarDetail(
  avatar: UserClientAvatar,
  t: TFn,
  autoEditField?: AvatarField.NAME | AvatarField.ROLE,
  isAnalyzing?: boolean,
): void {
  const fallbackTitle =
    avatar.id === -1
      ? (t(TKey.CLIENT_AVATAR_MODAL_CREATE_TITLE) as string)
      : (t(TKey.CLIENT_AVATAR_MODAL_DETAIL_TITLE) as string);
  const modalTitle = avatar.name || fallbackTitle;
  ModalStore.getState().openModal(
    Components.AvatarDetail,
    modalTitle,
    { avatar, params: { t }, autoEditField, isAnalyzing },
    ModalType.LARGE,
  );
}

export function buildEmptyAvatar(offerId: number): UserClientAvatar {
  return {
    id: -1,
    uuid: "",
    offerId,
    avatarUrl: "",
    name: "",
    role: "",
    gender: "",
    ageRange: [],
    locationRange: [],
    educationLevel: null,
    incomeRange: null,
    companyType: null,
    companySize: null,
    market: null,
    snapshotSummary: null,
    priority: null,
    dataSources: [],
    scoreFit: null,
    scoreConfidence: null,
    scorePain: null,
    desires: [],
    frustrations: [],
    dreams: [],
    fears: [],
    costTime: null,
    costEnergy: null,
    costOpportunity: null,
    currentSituation: [],
    desiredSituation: [],
    dailyRoutine: [],
    mindset: null,
    blockers: [],
    falseBelief: [],
    purchaseObjections: [],
    objectionHandler: [],
    privateQuotes: [],
    publicQuotes: [],
    dominantKeywords: [],
    emotionalLanguage: [],
    copyAdvice: null,
    fitSummary: null,
    urgencyLevel: null,
    urgencyDescription: null,
    purchasePotential: null,
    purchasePotentialDescription: null,
    idealClientCriteria: [],
    nonIdealClientCriteria: [],
    purchaseTriggers: [],
    whereToFind: [],
    voiceOfTrust: null,
    approachAngle: null,
  };
}

export function getAvatar(
  isAuthenticated: boolean,
  dbAvatars: UserClientAvatar[] | undefined,
  offerId: number,
): UserClientAvatar {
  if (!isAuthenticated) {
    return MOCK_AVATARS[0];
  }
  return dbAvatars?.[0] ?? buildEmptyAvatar(offerId);
}

export function computeInitials(name: string): string {
  return name
    .split(" ")
    .map((w) => w[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();
}

export const MOCK_AVATARS: UserClientAvatar[] = [
  {
    ...MOCK_AVATAR_DEFAULTS,
    id: 1,
    uuid: "mock-1",
    name: "Sophie D.",
    role: "Directrice marketing",
    gender: "Femme",
    ageRange: ["35", "45"],
    snapshotSummary:
      "Décideuse dans une PME de 50 à 200 salariés. Cherche à automatiser ses processus de prospection et à gagner du temps sur la qualification des leads. Sensible au ROI et aux preuves concrètes.",
    avatarUrl: "",
  },
];
